import { Button, Drawer, Typography } from "@shared/ui.primitives";
import React, { useEffect } from "react";
import { useSegment } from "tracking";

type Props = {
  description: string;
  onDismiss: () => void;
  isOpen: boolean;
};

export const TraditionalRetailModal: React.FC<Props> = ({
  description,
  onDismiss,
  isOpen
}) => {
  const { track } = useSegment();

  const handleDismiss = () => {
    track({
      event: "Page Element Clicked",
      properties: {
        module_content: "avg_typical_retail_price_pop_up",
        module_content_details: "close",
        location_type: "avg_typical_retail_price_pop_up"
      }
    });
    onDismiss();
  };

  useEffect(() => {
    if (isOpen) {
      track({
        event: "Page Element Viewed",
        properties: {
          module_content: "avg_typical_retail_price_pop_up",
          location_type: "avg_typical_retail_price_pop_up"
        }
      });
    }
  }, [track, isOpen]);

  return (
    <Drawer
      isOpen={isOpen}
      handleDismiss={handleDismiss}
      ariaDescription="See more about the traditional retail price of this product"
      ariaLabel="Traditional Retail Price"
      id="traditional-retail-price-drawer"
      dataTestId="traditional-retail-price-drawer"
      headerId="traditional-retail-price-drawer-header"
    >
      <Drawer.Header
        handleDismiss={handleDismiss}
        id="traditional-retail-price-drawer-header"
      >
        Traditional Retail Price
      </Drawer.Header>
      <Drawer.Body>
        <Typography as="p" variant="body-md">
          {description}
        </Typography>
      </Drawer.Body>
      <Drawer.Footer>
        <Button
          width="full"
          variant="secondary"
          onClick={handleDismiss}
          text="Back to product page"
        />
      </Drawer.Footer>
    </Drawer>
  );
};
